import React, { Component, createRef, Fragment } from 'react';
import FlowTitle from '../Flow/FlowTitle';
import StreamTDSDefaultStream from './StreamTDSDefaultStream';
import { Row, Col, FormGroup } from 'reactstrap';
import FlowSubAccount from '../Flow/FlowSubAccount/FlowSubAccount';
import FlowLink from '../Flow/FlowLink';
import _ from 'lodash';
import StreamTDSParkedDomain from "./StreamTDSParkedDomain";

class StreamTDSMain extends Component {
  constructor(props) {
    super(props);
    this._alertRefs = {
      ['titleError']: createRef(),
    };
  }
  componentDidMount() {
    const { saveRef } = this.props;
    saveRef(false, 'titleError', this._alertRefs.titleError);
  }
  render() {
    const {
      title,
      errors,
      handleChange,
      flow,
      onSelectChange,
      defaultStreams,
      isEdit,
      offers,
      getFlowsInfo,
      flowsInfo,
      offersInfo,
      handleSubAccountChange,
      getComputedLink,
      streamLink,
      streamTDS,
      saveRef,
      notFoundOffersInStreams,
      setFlowInfo,
      getOffersInfo,
    } = this.props;

    return (
      <Fragment>
        <Row>
          <Col lg="6" xs="10">
            <div ref={this._alertRefs.titleError} id="titleError">
              <FlowTitle title={title} onChangeTitle={handleChange} error={errors.titleError} />
            </div>
          </Col>
        </Row>
        {streamLink && isEdit ? (
          <FormGroup>
            <Row>
              <Col lg="6" xs="10">
                <FlowLink link={getComputedLink(streamLink)} />
              </Col>
            </Row>
            {streamTDS.domains && streamTDS.domains.length > 0 && (
              <Row>
                <Col lg="6" xs="10">
                  <StreamTDSParkedDomain domains={streamTDS.domains}/>
                </Col>
              </Row>
            )}
            <Row>
              <Col lg="6" xs="10">
                <FlowSubAccount onSubAccountChange={handleSubAccountChange} />
              </Col>
            </Row>
          </FormGroup>
        ) : null}
        <StreamTDSDefaultStream
          errorPath="flowError"
          errors={errors}
          changePath="flow"
          defaultStreams={defaultStreams}
          onSelectChange={onSelectChange}
          flow={flow}
          inScripts={false}
          offers={offers}
          getFlowsInfo={getFlowsInfo}
          flowsInfo={flowsInfo}
          offersInfo={offersInfo}
          saveRef={saveRef}
          notFoundOffersInStreams={notFoundOffersInStreams}
          setFlowInfo={setFlowInfo}
          getOffersInfo={getOffersInfo}
        />
      </Fragment>
    );
  }
}

export default StreamTDSMain;
